import jquery from 'jquery';
import moment from 'moment';
import momentDurationFormatSetup from 'moment-duration-format';

momentDurationFormatSetup(moment);

window.jQuery = jquery;
window.$ = jquery;

import 'mediaelement';

export default () => {
    $('#js-audio-player').mediaelementplayer({
        alwaysShowControls: true,
        features: ['current','progress','duration','playpause','volume'],
        audioVolume: 'horizontal',
        startVolume: 1,
    });

    $('.js-player-helper').each(function(index,elem){
        const $duration = $(elem).closest('.js-info').find('.js-duration');
        const $fileName = $(elem).closest('.js-info').find('.js-file-name');
        $(elem).on("canplaythrough", function(e){
            const seconds = e.currentTarget.duration;
            const duration = moment.duration(seconds, "seconds");

            let time = "";
            let hours = duration.hours();

            if (hours > 0) {
                time = duration.format('HH:mm:ss', {trim: false});
            } else {
                time = duration.format('mm:ss', {trim: false});
            }

            $duration.text(time);
        });
        $fileName.text($(elem).attr('src').substring($(elem).attr('src').lastIndexOf('/')+1));
        $(elem).hide();
    });

    $('audio.js-search-audio-player').each(function(){
        const $this = $(this);
        $this.mediaelementplayer({
            alwaysShowControls: true,
            features: ['playpause','progress','volume'],
            audioVolume: 'horizontal',
            startVolume: 1,
            defaultAudioHeight: 60,
            success: function (mediaElement) {
                const $controls = $this.closest('.mejs__container').find('.mejs__controls');
                $controls.prepend('<div class="mejs__time mejs__timeleft" role="timer"><span>timeleft is here</span></div>');
                const $timeleft = $controls.find('.mejs__timeleft > span');
                mediaElement.addEventListener('ended', function() {
                    $timeleft.text('00:00');
                }, false);
                mediaElement.addEventListener('timeupdate', function() {
                    const timeLeft = isNaN(mediaElement.duration) ? mediaElement.currentTime : mediaElement.duration - mediaElement.currentTime;
                    const timeLeftMoment = moment.duration(timeLeft, "seconds");
                    const hours = timeLeftMoment.hours();

                    let timeLeftFormated = timeLeftMoment.format('mm:ss',{trim: false});

                    if (hours > 0) {
                        timeLeftFormated = timeLeftMoment.format('HH:mm:ss',{trim: false});
                    }

                    if (isNaN(mediaElement.duration)) {
                        timeLeftFormated = '00:00'
                    } else {
                        timeLeftFormated = '-' + timeLeftFormated;
                    }

                    $timeleft.text(timeLeftFormated);
                }, false);
            },
        })
    })

}




// WEBPACK FOOTER //
// ./scripts/modules/player.js